import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IStepAddOrderFormValues,
  IStepCompetitionConfigFormValues,
  IStepOrderTableReport,
  StepOrderSide,
  StepOrderTypes,
} from "../../Interfaces/stepInterfaces";

interface IStepSlice {
  addOrderFormValues: IStepAddOrderFormValues | null;
  orderTableFetchDataFlag: boolean;
  tradeTableFetchDataFlag: boolean;
  editOrderRowValues: IStepOrderTableReport | null;
  operationType: StepOrderTypes;
  competitionConfigFormValues: IStepCompetitionConfigFormValues;
  competitionConfigTableFlag: boolean;
  competitionConfigFormModalOpen: boolean;
}

const initialState: IStepSlice = {
  addOrderFormValues: {
    orderSide: StepOrderSide.Buy,
    autoSellFund: false,
  } as IStepAddOrderFormValues,
  orderTableFetchDataFlag: false,
  tradeTableFetchDataFlag: false,
  editOrderRowValues: null,
  operationType: StepOrderTypes.Competition,
  competitionConfigFormValues: {} as IStepCompetitionConfigFormValues,
  competitionConfigTableFlag: false,
  competitionConfigFormModalOpen: false,
};

const StepSlice = createSlice({
  name: "step",
  initialState,
  reducers: {
    setStepAddOrderFormValues: (
      store,
      action: PayloadAction<IStepAddOrderFormValues>,
    ) => {
      store.addOrderFormValues = action.payload;
    },
    setStepOrderTableFetchDataFlag: (store, action: PayloadAction<boolean>) => {
      if (store.orderTableFetchDataFlag !== action.payload)
        store.orderTableFetchDataFlag = action.payload;
    },
    setStepTradeTableFetchDataFlag: (store, action: PayloadAction<boolean>) => {
      if (store.tradeTableFetchDataFlag !== action.payload)
        store.tradeTableFetchDataFlag = action.payload;
    },
    setStepEditRowValues: (
      store,
      action: PayloadAction<IStepOrderTableReport | null>,
    ) => {
      store.editOrderRowValues = action.payload;
    },
    setStepOrderOperationType: (
      store,
      action: PayloadAction<StepOrderTypes>,
    ) => {
      if (store.operationType !== action.payload)
        store.operationType = action.payload;
    },
    stepCompetitionConfigFormValuesChangeHandler: (
      store,
      action: PayloadAction<{ name: string; value: any }>,
    ) => {
      store.competitionConfigFormValues = {
        ...store.competitionConfigFormValues,
        [action.payload.name]: action.payload.value,
      };
    },
    setStepCompetitionConfigFormValues: (
      store,
      action: PayloadAction<IStepCompetitionConfigFormValues>,
    ) => {
      store.competitionConfigFormValues = action.payload;
    },
    setStepCompetitionTableFlag: (store, action: PayloadAction<boolean>) => {
      store.competitionConfigTableFlag = action.payload;
    },
    setStepCompetitionConfigFormModalOpen: (
      store,
      action: PayloadAction<boolean>,
    ) => {
      store.competitionConfigFormModalOpen = action.payload;
    },
  },
});

export const {
  setStepAddOrderFormValues,
  setStepOrderTableFetchDataFlag,
  setStepTradeTableFetchDataFlag,
  setStepEditRowValues,
  setStepOrderOperationType,
  stepCompetitionConfigFormValuesChangeHandler,
  setStepCompetitionTableFlag,
  setStepCompetitionConfigFormValues,
  setStepCompetitionConfigFormModalOpen,
} = StepSlice.actions;
export default StepSlice.reducer;
